<template>
  <ng-sheet outlined-bg="#f2f4f5" outlined sm class="product-meta dense-text">
    <v-row class="flex-nowrap">
      <template v-if="lastUpdated">
        <v-col cols="auto" class="product-meta__item py-2">
          <div class="x-small text-muted text-nowrap hidden-xs-only">{{ $t('product.lastUpdated') }}:</div>
          <div class="x-small text-muted text-nowrap hidden-sm-and-up">{{ $t('product.lastUpdatedShort') }}:</div>
          <div class="d-inline-block heading-font-family primary--text small">
            <v-icon v-if="isLastUpdatedToday" class="ml-n1" small color="primary"> mdi-flash </v-icon>
            <span class="text-capitalize">{{ lastUpdatedString }}</span>
            <v-tooltip class="ng-fieldset__help" right max-width="250">
              <template v-slot:activator="{ on }">
                <v-icon class="ng-fieldset__help-icon cursor-pointer ml-1" v-on="on" small>mdi-help-circle</v-icon>
              </template>
              {{ $t('product.lastUpdatedInfo') }}
            </v-tooltip>
          </div>
        </v-col>
        <v-divider vertical> </v-divider>
      </template>
      <template v-if="productionTime">
        <v-col cols="auto" class="product-meta__item py-2">
          <div class="x-small text-muted text-nowrap">{{ $t('product.readyWithin') }}:</div>
          <div class="d-inline-block heading-font-family primary--text small">{{ productionTimeString }}</div>
        </v-col>
        <v-divider vertical> </v-divider>
      </template>
      <template v-if="sources && sources.length > 0">
        <v-col class="product-meta__item py-2">
          <div class="x-small text-muted text-nowrap">{{ $t('product.source') }}:</div>
          <template v-for="(source, index) in sources">
            <a
              v-if="source.link"
              :key="`${source.text.replaceAll(' ', '')}-link`"
              :href="source.link"
              class="heading-font-family primary--text small nolink"
              target="_blank"
              >{{ source.text }}</a
            >
            <span
              v-else
              :key="source.text.replaceAll(' ', '')"
              class="d-inline-block heading-font-family primary--text small nolink"
              >{{ source.text }}</span
            >
            <span
              class="primary--text"
              v-if="index < sources.length - 1"
              :key="`${source.text.replaceAll(' ', '')}-comma`"
              >{{ `, ` }}</span
            >
            <!-- <v-icon color="primary" x-small style="position: relative; top: -1px">mdi-open-in-new</v-icon> -->
          </template>
        </v-col>
      </template>
    </v-row>
  </ng-sheet>
</template>

<script>
import { LAST_UPDATED_TODAY } from '@/constants/product/productConstants';
import { getProductionTimeString } from '@/utils/productUtils';

export default {
  name: 'ProductMeta',
  props: {
    lastUpdated: {
      type: String,
    },
    productionTime: {
      type: Number,
    },
    sources: {
      type: Array,
    },
  },
  computed: {
    lastUpdatedString() {
      return this.lastUpdated === LAST_UPDATED_TODAY ? this.$t('app.today') : this.lastUpdated;
    },
    isLastUpdatedToday() {
      return this.lastUpdated === LAST_UPDATED_TODAY;
    },
    productionTimeString() {
      return getProductionTimeString(this.productionTime);
    },
  },
};
</script>

<style lang="scss" scoped>
.product-meta {
  max-width: 100%;
  overflow: hidden;

  &__item {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
